import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { Url } from "../../../../../router/enums";
import { selectOwnerGeneralData } from "../owner.selectors";
import { setOwnerType } from "../owner.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.OWNER_GENERAL,
  selector: selectOwnerGeneralData,
  redirect: Url.OC_PROPERTY_DAMAGES,
  content: [
    {
      title: "Właściciel mienia",
      sections: [
        {
          id: "general-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.TYPE,
              required: true,
              label: "Kto jest właścicielem uszkodzonego mienia?",
              onChange: setOwnerType,
              items: [
                {
                  label: "osoba fizyczna",
                  value: "person",
                },
                {
                  label: "firma",
                  value: "company",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
